<template>
  <div class="sections-lateral-spaces max-w-2k mx-auto mt-24">
    <div class="nv-grid page-content" v-if="product && section">
      <ClientOnly>
        <portal to="header-title">
          <div class="nv-mb-2 nv-d-flex nv-align-items-center">
            <img :src="product?.logo.url || ''" class="nv-mr-1" :alt="t('product_logo', { name: product?.name })" v-if="product.logo">
            <h6 class="nv-m-0">
              {{ product.name }}
            </h6>
          </div>
          <h2 class="nv-mb-4">
            {{ section.name }}
          </h2>
        </portal>
      </ClientOnly>
  
      <div class="nv-grid-row">
        <SupportSectionAllTopics :section-slug="section.slug"/>
        <SupportSectionArticles :section-id="section.id!" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IPayloadCMSProducts } from '~/server/api/products/[slug]/types';
import { useProductStore } from '~/store/product';


// Types
definePageMeta({
  layout: 'support-kb',
  middleware: 'check-product-slug'
})

// ---------------------------------------
// Hooks
// ---------------------------------------
const { t } = useI18n();
const route = useRoute();

// ---------------------------------------
// Store
// ---------------------------------------
const productStore = useProductStore();

// ---------------------------------------
// State
// ---------------------------------------


const section = computed(() => (product.value?.supportSections.find((section) => section.slug === route.params.section) || {}) as IPayloadCMSProducts["docs"][number]["supportSections"][number]);


const { product } = storeToRefs(productStore);

useHead({
  title: t('product_help_section', { product: product.value?.name || '', section: section.value.name }),
})
</script>
